const CocosIslandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4152_111181)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#6DA544"
      />
      <path
        d="M30.701 28.6953L31.2498 29.8429L32.4892 29.5565L31.9342 30.7011L32.9308 31.4914L31.6899 31.7711L31.6934 33.0432L30.701 32.2473L29.7086 33.0432L29.7121 31.7711L28.4712 31.4914L29.4678 30.7011L28.9128 29.5565L30.1521 29.8429L30.701 28.6953Z"
        fill="#FFDA44"
      />
      <path
        d="M25.5955 16.5215L26.1444 17.6691L27.3838 17.3826L26.8287 18.5273L27.8253 19.3176L26.5845 19.5973L26.5879 20.8693L25.5955 20.0735L24.6031 20.8693L24.6065 19.5973L23.3657 19.3176L24.3624 18.5273L23.8073 17.3826L25.0467 17.6691L25.5955 16.5215Z"
        fill="#FFDA44"
      />
      <path
        d="M30.7019 9.56543L31.2507 10.713L32.4901 10.4264L31.9351 11.5711L32.9317 12.3615L31.6908 12.6411L31.6941 13.9132L30.7019 13.1174L29.7095 13.9132L29.7129 12.6411L28.4722 12.3615L29.4687 11.5711L28.9137 10.4264L30.153 10.713L30.7019 9.56543Z"
        fill="#FFDA44"
      />
      <path
        d="M35.1614 14.7832L35.7102 15.9308L36.9497 15.6443L36.3946 16.789L37.3913 17.5793L36.1504 17.859L36.1538 19.1311L35.1614 18.3352L34.1691 19.1311L34.1724 17.859L32.9316 17.5793L33.9283 16.789L33.3732 15.6443L34.6126 15.9308L35.1614 14.7832Z"
        fill="#FFDA44"
      />
      <path
        d="M31.9726 20.8701L32.4044 22.1988H33.8014L32.6712 23.0199L33.103 24.3484L31.9726 23.5274L30.8426 24.3484L31.2742 23.0199L30.144 22.1988H31.541L31.9726 20.8701Z"
        fill="#FFDA44"
      />
      <path
        d="M22.1739 25.6517C19.0523 25.6517 16.5217 23.1211 16.5217 19.9995C16.5217 16.878 19.0522 14.3473 22.1739 14.3473C23.1472 14.3473 24.0631 14.5935 24.8626 15.0267C23.6083 13.8 21.8931 13.043 19.9999 13.043C16.158 13.043 13.0435 16.1575 13.0435 19.9995C13.0435 23.8414 16.158 26.9559 19.9999 26.9559C21.893 26.9559 23.6083 26.1989 24.8625 24.9722C24.0631 25.4055 23.1472 25.6517 22.1739 25.6517Z"
        fill="#FFDA44"
      />
      <path
        d="M12.5763 7.82605C11.9748 6.78668 10.8517 6.08691 9.56453 6.08691C8.27734 6.08691 7.1543 6.78668 6.55273 7.82605H12.5763Z"
        fill="#FFDA44"
      />
      <path
        d="M12.588 7.84668L9.56463 10.87L6.54127 7.84668C6.25229 8.35379 6.08643 8.94027 6.08643 9.56574C6.08643 11.4868 7.64369 13.044 9.56471 13.044C11.4857 13.044 13.043 11.4868 13.043 9.56574C13.0429 8.94027 12.877 8.35379 12.588 7.84668Z"
        fill="#FFDA44"
      />
      <path
        d="M8.6958 10V12.9339C8.97369 13.0054 9.2651 13.0434 9.56533 13.0434C9.86557 13.0434 10.157 13.0053 10.4349 12.9339V10H8.6958Z"
        fill="#A2001D"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111181">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default CocosIslandSvg;
